import { t } from 'i18next';
import * as yup from 'yup';

import { getEmptyErrorMessage, numberSchemaWithTransform } from 'core/yup';

const getPricingGroupSchema = (index: number) => ({
  [`pricingGroup${index}`]: yup
    .string()
    .label(t(`labelPridcingGroup${index}`))
    .nullable(),
  [`pricingGroupDescription${index}`]: yup
    .string()
    .label(t(`labelPricingGroupDescription${index}`))
    .nullable(),
});

/**
 * `areQuantitiesRequired` is true for the single-part form, where a new catalogue
 * entry needs them. The audit page's bulk drawer passes false when the selection
 * is only parts that already have an entry: the fields are always sent when
 * required, so every selected part would have its own sales MOQ and increment
 * replaced by the one value typed here, even by someone who opened the drawer to
 * change a different column.
 */
export const corporatePartUpsertSchema = (areQuantitiesRequired = true) =>
  yup.object().shape({
    packageType: yup.string().label(t('labelType')).nullable(),
    minimumQuantity: areQuantitiesRequired
      ? numberSchemaWithTransform()
          .label(t('labelSalesMinimumOrderQuantity'))
          .required(getEmptyErrorMessage(t('labelSalesMinimumOrderQuantity')))
          .typeError(t('errorInvalidQuantity'))
      : numberSchemaWithTransform()
          .label(t('labelSalesMinimumOrderQuantity'))
          .nullable()
          .typeError(t('errorInvalidQuantity')),
    orderIncrement: areQuantitiesRequired
      ? numberSchemaWithTransform()
          .label(t('labelSalesOrderIncrements'))
          .required(getEmptyErrorMessage(t('labelSalesOrderIncrements')))
          .typeError(t('errorInvalidIncrements'))
      : numberSchemaWithTransform()
          .label(t('labelSalesOrderIncrements'))
          .nullable()
          .typeError(t('errorInvalidIncrements')),
    pkgUnits: numberSchemaWithTransform().label(t('labelPackageQuantity')).nullable(),
    bomPriceDecimals: numberSchemaWithTransform().label(t('labelBomPriceDecimals')).nullable(),
    quotePriceDecimals: numberSchemaWithTransform().label(t('labelQuotePriceDecimals')).nullable(),
    manufacturerMinimumQuantity: numberSchemaWithTransform()
      .label(t('labelVendorMinimumOrderQuantity'))
      .nullable(),
    manufacturerOrderIncrement: numberSchemaWithTransform()
      .label(t('labelVendorOrderIncrements'))
      .nullable(),
    className: yup.string().label(t('labelClass')).nullable(),
    taaStatus: yup.string().label(t('labelTaaStatus')).nullable(),
    companyPartStatus: yup.string().label(t('labelCompanyPartStatus')).nullable(),
    vendorNumber: yup.string().label(t('labelCompanyPartNumber')).nullable(),
    companyManufacturerName: yup.string().label(t('labelCompanyManufacturerName')).nullable(),
    companyManufacturerId: yup.string().label(t('labelCompanyManufacturerId')).nullable(),
    mfgPartStatus: yup.string().label(t('labelManufacturerPartStatus')).nullable(),
    replacementPart: yup.string().label(t('labelReplacementPart')).nullable(),
    partBaseCode: yup.string().label(t('labelPartBaseCode')).nullable(),
    ...getPricingGroupSchema(1),
    ...getPricingGroupSchema(2),
    ...getPricingGroupSchema(3),
    ...getPricingGroupSchema(4),
    ...getPricingGroupSchema(5),
  });
